const WHATSAPP_MSG = encodeURIComponent(
  "Hola, necesito un repuesto para Mitsubishi. Mi VIN es: ______ y busco: ______"
);

const categories = [
  {
    name: "Motor",
    icon: "ri-settings-5-line",
    img: "https://readdy.ai/api/search-image?query=Mitsubishi%20engine%20parts%20motor%20components%20pistons%20crankshaft%20professional%20automotive%20photography%20dark%20background%20red%20accent%20lighting%20clean%20studio&width=400&height=500&seq=cat001&orientation=portrait",
    desc: "Pistones, juntas, correas, bombas de agua y más",
  },
  {
    name: "Suspensión",
    icon: "ri-car-line",
    img: "https://readdy.ai/api/search-image?query=car%20suspension%20parts%20shock%20absorbers%20springs%20automotive%20spare%20parts%20professional%20photography%20dark%20background%20clean%20studio%20lighting&width=400&height=500&seq=cat002&orientation=portrait",
    desc: "Amortiguadores, resortes, rotulas y brazos",
  },
  {
    name: "Frenos",
    icon: "ri-stop-circle-line",
    img: "https://readdy.ai/api/search-image?query=brake%20system%20parts%20disc%20rotors%20brake%20pads%20calipers%20automotive%20spare%20parts%20professional%20photography%20dark%20background%20studio%20lighting&width=400&height=500&seq=cat003&orientation=portrait",
    desc: "Discos, pastillas, tambores y líquido de frenos",
  },
  {
    name: "Sistema de Dirección",
    icon: "ri-flashlight-line",
    img: "https://readdy.ai/api/search-image?query=automotive%20electrical%20system%20parts%20alternator%20starter%20motor%20sensors%20wiring%20harness%20professional%20photography%20dark%20background%20studio%20lighting&width=400&height=500&seq=cat004&orientation=portrait",
    desc: "Alternadores, sensores, fusibles y arneses",
  },
  {
    name: "Accesorios y Sistema eléctrico",
    icon: "ri-tools-line",
    img: "https://readdy.ai/api/search-image?query=Mitsubishi%20car%20accessories%20interior%20exterior%20parts%20mirrors%20handles%20trim%20professional%20automotive%20photography%20dark%20background%20studio%20lighting&width=400&height=500&seq=cat005&orientation=portrait",
    desc: "Espejos, manijas, molduras y más",
  },
];

export default function CategoriasSection() {
  return (
    <section id="categorias" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-3 block">
            Nuestro catálogo
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black mb-4">
            Categorías de Repuestos
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Contamos con repuestos para todas las necesidades de tu Mitsubishi. Consulta por WhatsApp y recibe asesoría inmediata.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {categories.map((cat) => (
            <div
              key={cat.name}
              className="relative rounded-xl overflow-hidden group cursor-pointer h-[340px] md:h-[400px]"
            >
              <img
                src={cat.img}
                alt={`Repuestos ${cat.name} Mitsubishi`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>

              {/* Icon */}
              <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-[#E10600] rounded-lg">
                <i className={`${cat.icon} text-white text-lg`}></i>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white font-black text-xl mb-1">{cat.name}</h3>
                <p className="text-white/70 text-xs mb-4">{cat.desc}</p>
                <a
                  href={`https://wa.me/573137659483?text=${encodeURIComponent(`Hola, necesito un repuesto de ${cat.name} para Mitsubishi. Mi VIN es: ______ y busco: ______`)}`}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-[#E10600] hover:bg-red-700 text-white text-xs font-bold px-4 py-2 rounded-full transition-all duration-200 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line"></i>
                  Consultar
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
